/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import SVG from "react-inlinesvg";
import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_helpers";
import { useSelector } from "react-redux";

export function QuickUser() {
  const navigate = useNavigate();

  const { user } = useSelector(state => state.auth);
  const userobject = user?.userData || user || {};
  const admin_role = userobject.admin_role || "admin";
  const userid = userobject.userid;
  const username = userobject.name || "";
  const useremail = userobject.email || "";

  // const update_url = "/admin/" + userid + "/edit"
  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    navigate("/logout");
  };

  return (
    <div id="kt_quick_user" className="offcanvas offcanvas-right offcanvas p-10">
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          User Profile
          </h3>
        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>

      <div
        className="offcanvas-content pr-5 mr-n5"
      >
        <div className="d-flex align-items-center mt-5">
          
          <div className="d-flex flex-column">
            <a
              href="#"
              className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
              onClick={(e) => {
                e.preventDefault();
                const profileUrl = userid
                  ? (userobject?.is_admin ? `/admin/${userid}/edit` : `/user/${userid}/edit`)
                  : null;
                if (profileUrl) navigate(profileUrl);
              }}
            >
              {username || "User"}
            </a>
            <div className="text-muted mt-1">{admin_role}</div>
            <div className="navi mt-2">
              <a href="#" className="navi-item">
                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Mail-notification.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {useremail}
                  </span>
                </span>
              </a>
            </div>
            {/* <Link to="/logout" className="btn btn-light-primary btn-bold">
                Sign Out
              </Link> */}
            <button className="btn btn-light-primary btn-bold" onClick={logoutClick}>Sign out</button>
          </div>
        </div>

        <div className="separator separator-dashed mt-6 mb-6" />

        <div className="navi navi-spacer-x-0 p-0 mb-6">
          <a
            href="#"
            className="navi-item"
            onClick={(e) => {
              e.preventDefault();
              const toggle = document.getElementById("kt_quick_user_toggle");
              if (toggle) toggle.click();
              navigate("/user-profile");
            }}
          >
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light-primary mr-3">
                <div className="symbol-label">
                  <i className="fa fa-user-cog text-primary"></i>
                </div>
              </div>
              <div className="navi-text">
                <div className="font-weight-bolder text-dark">My Profile</div>
                <div className="text-muted font-size-xs">View account details</div>
              </div>
            </div>
          </a>

          <a
            href="#"
            className="navi-item mt-3"
            onClick={(e) => {
              e.preventDefault();
              const toggle = document.getElementById("kt_quick_user_toggle");
              if (toggle) toggle.click();
              navigate("/user-profile");
            }}
          >
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light-warning mr-3">
                <div className="symbol-label">
                  <i className="fa fa-key text-warning"></i>
                </div>
              </div>
              <div className="navi-text">
                <div className="font-weight-bolder text-dark">Change Password</div>
                <div className="text-muted font-size-xs">Update your login security</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}